import React, { useEffect, useState } from "react";
import { Alert, Button, ButtonGroup, Form, Row, Col } from "react-bootstrap";
import InstagramOAuthPanel from "./InstagramOAuthPanel";
import WhatsAppEmbeddedSignupPanel from "./WhatsAppEmbeddedSignupPanel";

const ConfigTab = ({
    form,
    setForm,
    provider,
    channel,
    connectionId,
    onConnectionChanged
}) => {

    const isWhatsAppOfficial = channel === "whatsapp" && provider?.embeddedSignup;
    const [whatsAppSetupMode, setWhatsAppSetupMode] = useState(
        form.config?.oauth_managed === false || (form.config?.phone_number_id && !form.config?.oauth_connected)
            ? "manual"
            : "embedded"
    );

    useEffect(() => {
        if (!isWhatsAppOfficial) return;
        setWhatsAppSetupMode(
            form.config?.oauth_managed === false || (form.config?.phone_number_id && !form.config?.oauth_connected)
                ? "manual"
                : "embedded"
        );
    }, [
        connectionId,
        isWhatsAppOfficial,
        form.config?.oauth_connected,
        form.config?.oauth_managed,
        form.config?.phone_number_id,
    ]);

    if (!provider) {
        return null;
    }

    const updateField = (fieldName, value) => {

        setForm(prev => ({
            ...prev,
            config: {
                ...prev.config,
                [fieldName]: value
            }
        }));

    };

    const visibleFields = channel === "instagram"
        ? provider.fields?.filter(field => ![
            "instagram_app_name",
            "instagram_app_id",
            "app_secret",
            "login_type",
            "instagram_business_account_id",
            "access_token",
            "verify_token"
        ].includes(field.name))
        : isWhatsAppOfficial && whatsAppSetupMode === "embedded"
            ? provider.fields?.filter(field => ["country_code", "graph_version"].includes(field.name))
            : provider.fields;

    return (

        <>
            {channel === "instagram" && (
                <InstagramOAuthPanel
                    connectionId={connectionId}
                    config={form.config}
                    onConnectionChanged={onConnectionChanged}
                />
            )}
            {isWhatsAppOfficial && (
                <div className="mb-4 rounded border bg-white p-3">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div>
                            <strong>Como deseja configurar?</strong>
                            <div className="small text-muted mt-1">
                                Use a configuraÃ§Ã£o manual para testar com o nÃºmero e o token temporÃ¡rio fornecidos pela Meta.
                            </div>
                        </div>
                        <ButtonGroup aria-label="Modo de configuraÃ§Ã£o do WhatsApp Oficial">
                            <Button
                                type="button"
                                variant={whatsAppSetupMode === "embedded" ? "success" : "outline-secondary"}
                                onClick={() => setWhatsAppSetupMode("embedded")}
                            >
                                Conectar com a Meta
                            </Button>
                            <Button
                                type="button"
                                variant={whatsAppSetupMode === "manual" ? "primary" : "outline-secondary"}
                                onClick={() => {
                                    setWhatsAppSetupMode("manual");
                                    updateField("oauth_managed", false);
                                }}
                            >
                                ConfiguraÃ§Ã£o manual/teste
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            )}

            {isWhatsAppOfficial && whatsAppSetupMode === "embedded" && (
                <WhatsAppEmbeddedSignupPanel
                    connectionId={connectionId}
                    config={form.config}
                    onConnectionChanged={onConnectionChanged}
                />
            )}

            {isWhatsAppOfficial && whatsAppSetupMode === "manual" && (
                <Alert variant="info" className="small">
                    Para testes, informe o Phone Number ID, WhatsApp Business Account ID e token temporÃ¡rio exibidos no painel da Meta. O token expira e deverÃ¡ ser substituÃ­do quando necessÃ¡rio.
                </Alert>
            )}

            {/* Nome da conexão */}

            <Row className="mb-4">

                <Col md={12}>

                    <Form.Group>

                        <Form.Label>

                            Nome da conexão no Fluxo Clínica

                        </Form.Label>

                        <Form.Control
                            placeholder="Ex.: Recepção Clínica"
                            value={form.name}
                            onChange={(e) =>
                                setForm(prev => ({
                                    ...prev,
                                    name: e.target.value
                                }))
                            }
                        />

                        <Form.Text className="text-muted">

                            Nome interno usado para identificar esta conexão. Não precisa ser igual ao nome do app.

                        </Form.Text>

                    </Form.Group>

                </Col>

            </Row>

            {/* Campos do Provider */}

            <Row>

                {
                    visibleFields?.map((field) => (
                        <Col
                            md={field.col || 12}
                            key={field.name}
                            className="mb-4"
                        >

                            <Form.Group>

                                <Form.Label>

                                    {field.label}

                                    {

                                        field.required && (

                                            <span className="text-danger">

                                                {" "}*

                                            </span>

                                        )

                                    }

                                </Form.Label>

                                {
                                    field.type === "select" ? (
                                        <Form.Select
                                            value={
                                                form.config[field.name]
                                                ?? field.defaultValue
                                                ?? ""
                                            }
                                            onChange={(e) =>
                                                updateField(field.name, e.target.value)
                                            }
                                        >
                                            <option value="">Selecione...</option>

                                            {field.options?.map((option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : field.type === "checkbox" ? (
                                        <Form.Check
                                            type="switch"
                                            label={field.help || "Ativar"}
                                            checked={Boolean(form.config[field.name])}
                                            onChange={(e) =>
                                                updateField(field.name, e.target.checked)
                                            }
                                        />
                                    ) : field.type === "textarea" ? (
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            placeholder={field.placeholder || ""}
                                            value={form.config[field.name] || ""}
                                            onChange={(e) =>
                                                updateField(field.name, e.target.value)
                                            }
                                        />
                                    ) : (
                                        <Form.Control
                                            type={field.type || "text"}
                                            placeholder={field.placeholder || ""}
                                            value={form.config[field.name] || ""}
                                            onChange={(e) =>
                                                updateField(field.name, e.target.value)
                                            }
                                        />
                                    )
                                }
                                {

                                    field.help && (

                                        <Form.Text className="text-muted d-block mt-2">

                                            {field.help}

                                        </Form.Text>

                                    )

                                }

                            </Form.Group>

                        </Col>

                    ))

                }

            </Row>

        </>

    );

};

export default ConfigTab;
